<template>
  <div class="template-day-selector">
    <div class="template-day-selector__title">
      {{ title }}
    </div>
    <swiper
      v-if="!loading"
      ref="menuSlider"
      slides-per-view="auto"
      :space-between="8"
      :centered-slides="true"
      :update-on-window-resize="false"
      :centered-slides-bounds="true"
      class="template-day-selector__swiper"
      :class="swiperClass"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="(item, index) in templates"
        :key="'day-selector'+index"
        class="template-day-selector__slide"
      >
        <template-option
          :is-active="index === activeIndex "
          @click="setActive(item)"
        >
          <template #name>
            {{ item.frontName }}
          </template>
        </template-option>
      </swiper-slide>
    </swiper>
    <swiper
      v-else
      ref="menuSlider"
      slides-per-view="auto"
      :space-between="8"
      :centered-slides="true"
      :centered-slides-bounds="true"
      class="template-day-selector__swiper"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="item in 3"
        :key="'day-selector'+item"
        class="template-day-selector__slide"
      >
        <template-option class="_skeleton">
          <template #name>
            <span
              class="skeleton-box radius"
              style="width:0.9rem;height:0.16rem;margin-bottom:0;display:inline-flex;"
            />
          </template>
        </template-option>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>

import TemplateOption from './TemplateOption.vue'
import { Swiper, SwiperSlide } from 'swiper/swiper-vue'

export default {
  name: 'TemplateDaySelector',
  components: {
    Swiper,
    SwiperSlide,
    TemplateOption,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    templates: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value'],
  data () {
    return {
      mount: false,
      mySwiper: null,
    }
  },
  computed: {
    swiperClass () {
      return {
        'template-day-selector__swiper--length-1': this.templates.length === 1,
        'template-day-selector__swiper--length-2': this.templates.length === 2,
      }
    },
    activeIndex () {
      if (!this.value) {
        return 0
      }
      return this.templates.findIndex((item) => {
        return this.value.templateId === item.templateId
      })
    },
  },
  mounted () {
    this.mount = true
    this.checkValue()
  },
  methods: {
    setSwiper (swiper) {
      this.mySwiper = swiper
      this.checkValue()
    },
    checkValue () {
      if (!this.value && this.mySwiper) {
        this.setActive(this.templates[0] || null)
      }
    },
    setActive (item) {
      this.$emit('update:value', item)
      if (this.mySwiper) {
        setTimeout(() => {
          this.mySwiper.slideTo(this.activeIndex, 300)
        }, 0)
      }
    },
  },
}
</script>

<style lang="scss">
$prefix: 'template-day-selector';
.#{$prefix} {
  margin: 0 auto 0.24rem auto;
  width: 100%;
  padding: 0.02rem .16rem;
  overflow: hidden;
  &__title {
    margin-bottom: .16rem;
    text-align: center;
    letter-spacing: 0.008rem;
    text-transform: uppercase;
    font-weight: 600;
    font-size: .12rem;
    line-height: .16rem;
    color: #999999;
  }
  &__swiper {
    overflow: visible !important;
    padding-top: .04rem !important;
    padding-bottom: 0.01rem !important;
    &--length {
      &-1 {
        .#{$prefix} {
          &__slide {
            min-width: 100%;
          }
        }
      }
      &-2 {
        .#{$prefix} {
          &__slide {
            min-width: calc(50% - 4px);
          }
        }
      }
    }
  }
  &__slide {
    width: fit-content !important;
    min-width: 1.6rem !important;
    white-space: nowrap;
  }
}
</style>
